// #region Dependencias
import { useState, useEffect } from 'react'
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledContainer = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
`

const StyledIFrameContainer = styled.div`
  height: 542px;
  width: 964px;
`

const StyledIFrame = styled.iframe.attrs((props) => ({
  style: {
    borderRadius: `${props.borderradius}rem`
  }
}))`
  background-color: black;
  border: 0;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  display: block;
  height: 95%;
  margin: auto;
  width: 95%;
`
// #endregion

/**
 * Componente para mostrar un reproductor de video embebido de YouTube.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.video - URL del video de YouTube a mostrar.
 * @param {boolean} props.mostrarVideo - Valor que indica si el video se está mostrando.
 * @param {Function} props.setMostrarVideo - Función para actualizar el estado de mostrarVideo.
 */
const VideoPlayer = ({ video, mostrarVideo, setMostrarVideo, ...props }) => {
  const [videoEmbed, setVideoEmbed] = useState('')

  /**
   * Hook useEffect que establece la URL del video embebido de YouTube correspondiente.
   */
  useEffect(() => {
    const videoId = video.split('=')[1] // Se obtiene el ID del video desde la URL.
    // setVideoEmbed(`https://www.youtube.com/embed/${videoId}?autoplay=1&loop=1&controls=0&rel=0&showinfo=0`);
    setVideoEmbed(`https://www.youtube.com/embed/${videoId}`)
  }, [video])
  // ?version=3&autoplay=1&mute=1&controls=0&loop=1&playlist=c2N57vCUVi4
  /**
   * Hook useEffect que actualiza el estilo de la página para mostrar u ocultar
   * la barra de desplazamiento dependiendo si el video se está mostrando o no.
   */
  useEffect(() => {
    if (mostrarVideo) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }, [mostrarVideo])

  /**
   * Se renderiza el componente si se está mostrando el video.
   */
  if (mostrarVideo) {
    return (
      <StyledContainer onClick={() => setMostrarVideo(false)}>
        <StyledIFrameContainer>
          <StyledIFrame {...props} src={videoEmbed} allow="autoplay" />
        </StyledIFrameContainer>
      </StyledContainer>
    )
  }
}

export default VideoPlayer
